module.exports = __webpack_public_path__ + "static/media/6.fc276459.JPG";